var WatermarkText = 'Search';
var lightText = '#616161';
var typeText = '#2c2c2c';
var searchClicked = false;

$(function () {
     
    //Added to prevent autocomplete from closing if the suggestion panel is clicked on
    //If outside the area is clicked on then both the autocomplete and suggestion panel are hidden
    $(document).mousedown(function(e) 
    {
	    var target = $(e.target)
	    
	    //Checks if the click was inside the autocomplete area or anything inside the search panel
	    if (target.is('#SuggestionPanel') || target.is('.ui-autocomplete') || target.is('.SuggestionBox') || target.parents('.SuggestionBox').length)
	    {
	    	     //Prevents the autocomplete drop down from closing if a click occurs in a specified area
		     e.preventDefault();
	    }
	    else
	    {
	    		//Hides the suggestion panel because the click was outisde a specified area
	    		//The autocomplete closes automatically and does not need to be specfically closed
	    		$(this).find('#SuggestionPanel').hide();
	    }
    });

    $('.searchTextbox').css('color', lightText).bind('focus', function (event) {
        if ($(event.target).val() == WatermarkText) {
            $(event.target).val('').css('color', typeText);
        }
    }).bind('blur', function (event) {
        if ($.trim($(event.target).val()) == '') {
            $(event.target).val(WatermarkText).css('color', lightText);
        }
    }).val(WatermarkText).keypress(function (e) {
        var code = e.which;
        if (code == 13) {
            e.preventDefault();
            Search(this);
        }
    }).autocomplete({
        minLength: 3,
        delay: 500,
        focus: function (event, ui) {
            //If the up or down arrow is hit then update the search text box term.
            if(event.keyCode == 38 || event.keyCode == 40){
                //update the value
                this.value = ui.item.term;
                event.preventDefault();
            }
        }, 
        open: function () {
            $(this).data("ui-autocomplete").menu.element.addClass("autocomplete").css("z-index", "1006");
        },
        appendTo: $("#pnlSearch"),
        select: function (event, ui) {
            this.value = ui.item.term;
            event.preventDefault();
            Search(this);
        },
        source: function (req, resp) {
        	//$('#pnlSearch .ui-autocomplete').attr('aria-live', 'polite');
     		//$('#pnlSearch .ui-autocomplete').attr('aria-atomic', 'true');
            $.ajax({
                type: "POST",
                url: "/Header/SearchAutoComplete",
                dataType: "json",
                data: { searchTerm: req.term },
                timeout: 15000,
                async: true,
                success: function (result) {
                    var suggestions = [];
                    $.each(result, function (i, val) {
                        suggestions.push({
                            term: val.SearchTerm,
                            count: val.ResultCount                            
                        });
                    });
                    resp(suggestions);
                    
                    //Checks to see if there are items in the array
                    //Hides the panel if there are none and searches the searched word if there are results
                    if (suggestions.length === 0)
                    {
                        $('#SuggestionPanel').hide();
                        $('#searchStatus').html('No autocomplete results available');
                    }
                    else
                    {
	                    showUserSearchTerm(req.term);
	                    $('#searchStatus').html(suggestions.length + ' autocomplete results are available for '+ $('#txtSearch').val() + ', use up and down arrow keys to navigate.');
                    }
                }
            });
        }
    }).data("ui-autocomplete")._renderItem = function (ul, item) {
        var re = new RegExp("(" + this.term + ")", "gi");
        return $("<li></li>")
            .data("ui-autocomplete-item", item)
            .append("<a><div class='searchAutoLeft'>" + item.term.replace(re, "<span class='bold'>$1</span>") + "</div><div class='searchAutoRight'>" + item.count + " results</div><div class='clear'></div></a>")
            .appendTo(ul);
    };
    $("#submitSearch").on("click", function (e) {
        e.preventDefault();
        Search(this);
    });
});

function Search(e) {
    if (e.id != "submitSearch") {
        $("#submitSearch").trigger("click");
        return false;
    }
    var searchText = $.trim($('.searchTextbox').val());
    if (searchText == "") {
        return false;
    }
    searchClicked = true;
    $.ajax({
        type: "POST",
        url: "/Header/Search",
        dataType: "json",
        data: { searchText: searchText },
        timeout: 15000,
        async: true,
        success: function (result) {
            window.location.replace(result.url);
        }
    });
}

function variableDefined(name) {
    return typeof this[name] !== 'undefined';
}

function showUserSearchTerm(searchTerm)
{
     //Creates the values to reset the search panel
     var styles = {
        position: "absolute",
        top: "0px",
        left: "0px"
    };
    
    //Resets the css values for top and left to prevent bug from causing improper position
    $('#SuggestionPanel').css(styles);
    
    //Sets the position of the suggestion panel to the right of the autocomplete drop down
    $('#SuggestionPanel').position({
	my: "left top",
	at: "right top",
	of: ".ui-autocomplete",
	collision: "none"
	});   
    
    //Trys to hide the suggestion panel before a new one is attempted to be loaded
    //This allows the slide animation to work each time when displaying a new panel
    $('#SuggestionPanel').hide('slide', { direction: 'left' }, 250);

    $.ajax({
                type: "POST",
                url: "/Header/SearchBoxSuggestions",
                dataType: "html",
                data: { searchTerm: searchTerm },
                timeout: 20000,
                async: true,
                success: function (result) 
                {
				//Fills the suggestion panel with the results
				$('#SuggestionPanel').html(result);
				//Shows the suggestion panel by sliding it from the left
				$('#SuggestionPanel').show('slide', { direction: 'left' }, 250);                	  
               }//end success
            });
}//end showSearchMenu

$('#SuggestionPanel').on('keypress', '#SearchSuggestionPanelViewAll',
	function(e)
	{
		var keyCode = e.keyCode || e.which;			
		if (keyCode == 9) {
            		e.preventDefault();
            		$('.lnkAdvancedSearch').focus();
            		$('#SuggestionPanel').hide();
		}
	}
);

$('#pnlSearch').on('keyup','#txtSearch', 
	function(e){
		var keyCode = e.keyCode || e.which;
		if(keyCode == 38 || keyCode == 40){
			$('.searchAutoLeft').each( 
				function(){ 
					if($(this).html().replace(/<[^>]*>/gi, "") == $('#txtSearch').val())
					{
						$('#searchStatus').html($(this).next().html());
					}
				}
			);
		}
	}
);